<template>
  <v-container>
    <v-card class="pa-4" shaped elevation="4"  outlined>
<!--      <v-list-item one-line>-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title class="text-h5 ">-->
<!--  وضعیت پرداخت-->
<!--          </v-list-item-title>-->
<!--&lt;!&ndash;          <v-list-item-subtitle>Mon, 12:30 PM, Mostly sunny</v-list-item-subtitle>&ndash;&gt;-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->
      <v-row >
        <h3 class="text-right my-6 ml-auto mr-6">وضعیت پرداخت</h3>
          <v-btn
              color="success"
              dark
              small
              class="ma-6 "
              rounded
              width="15%"
              min-width="70px"
              @click="print"
          >
            چاپ
            <v-icon
                class="mx-1"
                medume
                color="white"
            >
              mdi-printer
            </v-icon>         
             </v-btn>

      </v-row>

      <v-simple-table class="table mt-2" dense>
        <thead>
        </thead>
        <tbody>
        <tr>
          <td class="left">وضعیت</td>
          <td class="right" :style="[User_Payment_Status.StatusID == 0 ? {'color': 'green'} : {'color': 'red'}]">{{ User_Payment_Status.Status }} </td>
        </tr>
        <tr>
          <td class="left">مرجع</td>
          <td class="right">{{ User_Payment_Status.Reference }} </td>
        </tr>
        <tr>
          <td class="left"> درگاه پرداخت</td>
          <td class="right">
             {{ institute_info.Title }} - {{ User_Payment_Status.GW.Name }} {{ User_Payment_Status.GW.ID }}
          </td>
        </tr>

        <tr>
          <td style="direction: rtl" class="left">بابت</td>
          <td class="right" v-html="User_Payment_Status.TerminalID+' - '+User_Payment_Status.Group"></td>
        </tr>

        <tr >
          <td class="left">مبلغ</td>
          <td class="right"><span style="visibility: hidden;">م</span> {{Number(User_Payment_Status.amount).toLocaleString()}} {{ rial }} </td>
        </tr>

        <tr>
          <td class="left">زمان</td>
          <td class="right">{{ User_Payment_Status.CreateOn }} </td>
        </tr>

        <tr>
          <td class="left">OrderID</td>
          <td class="right">{{ User_Payment_Status.OrderID }} </td>
        </tr>
        <tr v-if="userGroupLoad.Memo_Enable">
          <td class="left">{{ userGroupLoad.Memo_Title }}</td>
          <td class="right">{{ User_Payment_Status.Memo }} </td>
        </tr>
<!--        <tr>-->
<!--          <td>TerminalID</td>-->
<!--          <td>{{ User_Payment_Status.TerminalID }} </td>-->
<!--        </tr>-->

        <tr v-if="userGroupLoad.NC_Enable">
          <td class="left">کد ملی</td>
          <td class="right">{{ User_Payment_Status.NC }}</td>
        </tr>

        <tr v-if="userGroupLoad.Name_Enable">
          <td class="left">نام</td>
          <td class="right">{{ User_Payment_Status.Name }} </td>
        </tr>

        <tr v-if="userGroupLoad.Family_Enable">
          <td class="left">
            نام خانوادگی
          </td>
          <td class="right">{{ User_Payment_Status.Family }}</td>
        </tr>


        <tr v-if="userGroupLoad.Mobile_Enable">
          <td class="left">همراه</td>
          <td class="right">{{ User_Payment_Status.Mobile }}</td>
        </tr>

        <tr v-if="userGroupLoad.EMail_Enable">
          <td class="left">ایمیل</td>
          <td class="right">{{ User_Payment_Status.Email }}</td>
        </tr>
        <tr v-if="userGroupLoad.Tel_Enable">
          <td class="left">تلفن</td>
          <td class="right">{{ User_Payment_Status.Tel}}</td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card>
  </v-container>
</template>


<script>
import {mapState} from "vuex";

export default {
  name: "PaymentStatus",
  data: () => ({
    rial:"ریال"
  }),
  computed: mapState({
    User_Payment_Status: (state) => state.PaymentStatus,
    institute_info: (state)=> state.institute_info,
    userGroupLoad: (state)=> state.userGroupLoad_two
  }),
  created() {
    window.console.log(this.User_Payment_Status , 'userstatus');
    window.console.log("PaymentResult Component Is Created!");
    this.$store.commit("pushQueue", {
      functionName: "User_Payment_Status",
      data: {
       GWID: this.$route.params.GWID,
       OrderID: this.$route.params.OrderID,
        NC: this.$route.params.NC
      }
    });
  },
  methods: {
    print:function (){
      window.print();
    }
  },
}

</script>

<style scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(200, 200, 200, 0.1);
}
tbody td {
  font-size: 80% !important;
}
.paginate_section{
  margin: 20px 0;
}
.table {
  justify-content: center;
  border: 1px solid #ededed;
}
.T-head{
  color: black!important;
  font-size:small !important;
}
.table td{
  direction: ltr!important;
}
.right{
  text-align: right;
}
.left{
  text-align: left;
}
.border{
  border: 1px solid rgb(228, 228, 228);
}
</style>




<!--User_Payment_Status":{"GW":{"ID":7,"Name":"پارک علم و فناری"},"OrderID":19,"CreateOn":"1397\/08\/22 18:13:37","NC":"2031675699","Name":"مقداد","Family":"شكيبا","Tel":"66164025","Mobile":"09121771941","Email":"mshakiba2000@yahoo.com","amount":1000,"Reference":"142695259673","Status":"0:142695259673","Memo":"","TerminalID":100,"Group":"تایمرا"}}-->
